import React from 'react';

export const BetPoints = (props: { points: number | undefined }) => {
    return props.points !== undefined && props.points != null  ?
        <span className="btn-r1--points ps-sm-1 pe-sm-1">{props.points}</span>
        :
        <span className="btn-r1--points ps-sm-1 pe-sm-1">0</span>;
};
